import { render, staticRenderFns } from "./ContratTemplateForm.vue?vue&type=template&id=9112e32a&"
import script from "./ContratTemplateForm.vue?vue&type=script&lang=js&"
export * from "./ContratTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports